// extracted by mini-css-extract-plugin
export default {"link":"cr_kc","title":"cr_c1","desc":"cr_fV"};